// @index('./*', pp => `export * from "${pp.path}";`)
export * from './ArrayInputType';
export * from './IArrayInputOptions';
export * from './IArrayInputOptionsTemplate';
